import React from 'react'
import { Col, Container, Row } from '@/atoms/Grid'
import InsuranceCard from '@/molecules/InsuranceCard'
import * as S from './styles'

const BlogCards = ({ items, title, description, theme = 'white' }) => {
  return (
    <S.BlogCards>
      <Container>
        <S.BlogCardsContent>
          {title ? <S.BlogCardsTitle bold typo="displaySM">{title.content}</S.BlogCardsTitle> : null}
          {description ? (
            <S.BlogCardsDescription>{description}</S.BlogCardsDescription>
          ) : null}
        </S.BlogCardsContent>
        <S.BlogCardsWrapper>
          <Row>
            {items.map((item, i) => {
              return (
                <Col
                  xs={12}
                  lg={6}
                  key={i}
                >
                  <InsuranceCard
                    {...item}
                    colorScheme={theme}
                  />
                </Col>
              )
            })}
          </Row>
        </S.BlogCardsWrapper>
      </Container>
    </S.BlogCards>
  )
}

export default BlogCards
